import { Paginated } from "../../../../common/domain/models/paginated_models";
import { GrupoAcesso } from "../../domain/models/grupo_acesso";
import { GestorGrupo } from "../../domain/models/gestor_grupo";
import { DeleteGrupoAcessoRequest } from "../daos/delete/delete_grupo_acesso_request";
import { IAdministracaoService } from "../services/administracao_service";
import { IAdministracaoRepository } from "../../domain/repositories/administracao_repository";
import { UsuariosListaDao } from "../../domain/models/usuariosLista";
import { Usuario } from "../../domain/models/usuario";
import { CentroCusto } from "../../../comercial/domain/models/centro_custo";
import { AtribuicaoGrupo } from "../../domain/models/atribuicao_grupo";
import { PermissaoAcessoGrupoLista } from "../../domain/models/permissao_acesso_grupo_lista";
import { PermissaoCadastro } from "../../domain/models/permissao_cadastro";
import { GetSpaceUsedBDResponse } from '../daos/read/get_space_used_bd';
import { AtributoSistemaModel } from '../../domain/models/atributos_sistema';
import { EspacoUtilizadoBD } from "../../domain/models/espaco_utilizado_bd";
import { GetUsuariosTotalResponse } from "../daos/read/get_usuarios_total";
import { NroUsuariosTotal } from "../../domain/models/nro_usuarios_total";

/**
 * AdministrationRepository
 */

export class AdministracaoRepository implements IAdministracaoRepository {
  constructor(
    private readonly service: IAdministracaoService,
  ) { }

  //#region  Grupo Acesso
  async getGruposAcesso(
    page: number | null,
    pageSize: number | null,
    nome: string | null,
    descricao: string | null,
    status: number | null,
  ): Promise<Paginated<GrupoAcesso>> {
    const request = { page, pageSize, nome, descricao, status };
    const response = await this.service.getGruposAcesso(request);
    return {
      items: [...response.items],
      totalItems: response.totalItems,
      totalPages: response.totalPages,
      currentPage: response.currentPage,
      pageSize: response.pageSize,
    };
  }

  async getGrupoAcesso(
    idGrupoAcesso: number,
  ): Promise<GrupoAcesso> {
    const response = await this.service.getGrupoAcesso({ idGrupoAcesso });
    return { ...response };
  }

  async deleteGrupoAcesso(
    idGrupoAcesso: number,
  ): Promise<void> {
    const request: DeleteGrupoAcessoRequest = { idGruposAcesso: idGrupoAcesso };
    await this.service.deleteGrupoAcesso(request);
  }

  async getGestores(
  ): Promise<GestorGrupo[]> {
    const response = await this.service.getGestores();
    return [...response.items];
  }

  async getAllAtribuicaoGrupoLista(
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<AtribuicaoGrupo>> {
    const response = await this.service.getAllAtribuicaoGrupoLista({ currentPage: page ?? 1, rowsPerPage: rowsPerPage ?? 100 });
    return { ...response };
  }


  async createGrupoAcesso(
    nomeGrupo?: string | null,
    descricao?: string | null,
    idFuncionario?: number | null,

    idsAtribuicaoGrupo?: number[]
  ): Promise<number> {
    const request = {
      nomeGrupo,
      descricao,
      idFuncionario,
      idsAtribuicaoGrupo
    };
    const response = await this.service.createGrupoAcesso(request);
    return response.idGrupoAcesso;
  }

  async updateGrupoAcesso(
    idGrupoAcesso: number,
    nomeGrupo?: string | null,
    descricao?: string | null,
    ativo?: boolean | null,
    idFuncionario?: number | null,

    idsAtribuicaoGrupo?: number[]
  ): Promise<void> {
    const request = {
      idGrupoAcesso,
      nomeGrupo,
      descricao,
      ativo,
      idFuncionario,
      idsAtribuicaoGrupo
    };

    await this.service.updateGrupoAcesso(request);

  }


  async getAllPermissaoGrupoAcesso(idGrupoAcesso: number): Promise<PermissaoAcessoGrupoLista[]> {
    const response = await this.service.getAllPermissaoGrupoAcesso({ idGrupoAcesso });
    return [...response.items];
  }

  async createPermissaoGrupoAcesso(request: PermissaoCadastro[], idGrupoAcesso: number): Promise<void> {
    await this.service.createPermissaoGrupoAcesso({ items: request, idGrupoAcesso });

  }

  async updateAtributoSistema(
    idAtributoSistema: number,
    limparArquivo: boolean,
    nomeCliente?: string,
    logoCliente?: string,
    extensaoLogo?: string,
  ): Promise<void> {
    const request = {
      idAtributoSistema,
      nomeCliente,
      logoCliente,
      extensaoLogo,
      limparArquivo
    };
    await this.service.updateAtributoSistema(request);
  }

  async getAtributoSistema(): Promise<AtributoSistemaModel> {
    const response = await this.service.getAtributoSistema();
    return { ...response };
  }

  async getSpaceUsedBD(): Promise<EspacoUtilizadoBD> {
    const response = await this.service.getSpaceUsedBD();
    return { ...response };
  }

  //#endregion



  //#region  usuarios

  async createUsuario(
    nome: string,
    login: string,
    senha: string,
    email: string,
    centroCustoRestrito: boolean,
    bloqueado: boolean,
    idFuncionario?: number,
    isConfigured?: boolean,

    gruposUsuario?: number[],
    restricoesCentroCusto?: number[],

  ): Promise<number> {
    const request = {
      nome,
      login,
      senha,
      email,
      centroCustoRestrito,
      bloqueado,
      idFuncionario,
      isConfigured,

      gruposUsuario,
      restricoesCentroCusto,
    };
    const response = await this.service.createUsuario(request);
    return response.idUsuario;
  }

  async updateUsuario(
    idUsuario: number,
    nome: string,
    login: string,
    senha: string | null,
    email: string,
    centroCustoRestrito: boolean,
    bloqueado: boolean,
    isConfigured?: boolean,

    idFuncionario?: number,
    gruposUsuario?: number[],
    restricoesCentroCusto?: number[],
  ): Promise<void> {
    const request = {
      idUsuario,
      nome,
      login,
      senha,
      email,
      centroCustoRestrito,
      bloqueado,
      isConfigured,

      idFuncionario,
      gruposUsuario,
      restricoesCentroCusto,
    };
    await this.service.updateUsuario(request);
  }

  async getAllUsuariosLista(
    nome?: string,
    login?: string,
    email?: string,
    status?: number,
    idsGrupoAcesso?: number[],
    idsCentroCusto?: number[],

    currentPage?: number | null,
    rowsPerPage?: number | null,
  ): Promise<Paginated<UsuariosListaDao>> {
    const response = await this.service.getAllUsuariosLista({
      nome, login, email, status, idsGrupoAcesso, idsCentroCusto, currentPage, rowsPerPage
    });
    return {
      items: [...response.items.map(item => ({ ...item, idUsuario: item.idUsuario ?? 0 }))],
      totalItems: response.totalItems,
      totalPages: response.totalPages,
      currentPage: response.currentPage,
      pageSize: response.pageSize,

    };
  }

  async getUsuariosTotal(): Promise<NroUsuariosTotal> {
    const response = await this.service.getUsuariosTotal();
    return { ...response };
  }

  async deleteUsuario(idUsuario: number): Promise<void> {
    await this.service.deleteUsuario(idUsuario);

  }

  async getUsuarioById(idUsuario: number): Promise<Usuario> {
    const response = await this.service.getUsuarioById({ idUsuario });
    return { ...response };

  }

  async bloqueioUsuarioById(idUsuario: number): Promise<void> {
    await this.service.bloqueioUsuarioById(idUsuario);
  }

  async getCentroCustoRestricoesUsuario(
    page?: number,
    rowsPerPage?: number): Promise<Paginated<CentroCusto>> {
    const response = await this.service.getAllCentroCustoRestricaoUsuario({
      currentPage: page,
      rowsPerPage: rowsPerPage
    });
    return { ...response }

  }

  //#endregion
}